<template xmlns="http://www.w3.org/1999/html">
	<div>
		<p>{{placeHold}}</p>
		<p v-show="errors.has('textarea')"
		   class="help is-danger">X</p>
		<textarea class="topcoat-textarea"
		          v-validate="vali"
		          data-vv-name="textarea"
		          :class="{'is-danger': errors.has('textarea') }"
		          :placeholder="placeHold"
		          v-model.trim="value">
		</textarea>

	</div>
	<!--<div class="control column is-4">-->
	<!--<label class="label">{{placeHold}}</label>-->
	<!--<textarea v-validate="vali"-->
	<!--data-vv-name="textarea"-->
	<!--class="textarea"-->
	<!--:class="{'is-danger': errors.has('textarea') }"-->
	<!--:placeholder="placeHold"-->
	<!--v-model.trim="value"></textarea>-->
	<!--<p v-show="errors.has('textarea')"-->
	<!--class="help is-danger">-->
	<!--{{ errors.first('textarea') }}-->
	<!--</p>-->
	<!--</div>-->
</template>

<script>
	import randPara from 'random-paragraph'
	export default {
		name: 'hello',
		data () {
			return {
				placeHold: '',
				value: '',
				vali: {rules: {required: true, in: []}}
			}
		},
		methods: {
			randomParagraph () {
				return randPara({min: 1, max: 2});
			}
		},
		created() {
			const randPara = this.randomParagraph()
			this.placeHold = randPara
			this.vali.rules.in[0] = randPara
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	label {
		padding: 0 10px;
	}

	p {
		margin: 5px 20px;
		width: 360px;
	}

	textarea {
		width: 400px;
		height: 140px;
	}

	div {
		float: left;
	}
	textarea.is-danger {
		border-color: #ff3860;
	}
</style>



// WEBPACK FOOTER //
// TextBlock.vue?baac0e3c